/* Publish by EComposer at 2024-06-05 17:19:57*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-ez58chavdga"]=  window.__ectimmers["ecom-ez58chavdga"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var e=this.$el.querySelector("[ecom-modal]");new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+this.id]})}

                    });
                    
                        document.querySelectorAll('.ecom-ez58chavdga').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ez58chavdga', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5q7ic6mjaq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5q7ic6mjaq', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-ruovyhhl85s"]=  window.__ectimmers["ecom-ruovyhhl85s"] || {};
var e;if(!this.$el)return;const t=this.$el;if(this.settings.style==="slider"){let i=t.querySelector(".ecom-swiper-container"),s=i&&i.dataset.optionSwiper;if(!s)return;let l="bullets";this.settings.slider_pagination_style==="progress"&&(l="progressbar"),s=JSON.parse(s),s.pagination={el:t.querySelector(".ecom-swiper-pagination"),type:l,clickable:!0},s.navigation={nextEl:t.querySelector(".ecom-swiper-button-next"),prevEl:t.querySelector(".ecom-swiper-button-prev")},s.autoHeight=!1,s.spaceBetween=(e=this.settings.slider_spacing)!=null?e:25,window.EComSwiper&&new window.EComSwiper(i,s)}

                    });
                    
                        document.querySelectorAll('.ecom-ruovyhhl85s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ruovyhhl85s', settings: {"style":"grid"},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}